const clientItems = require('../config/clientItems.json');

export const ClientItem = (id: number) => {
    return clientItems[id] ?? null;
}